import { render, staticRenderFns } from "./TeamRoster.vue?vue&type=template&id=844b43a4&"
import script from "./TeamRoster.vue?vue&type=script&lang=ts&"
export * from "./TeamRoster.vue?vue&type=script&lang=ts&"
import style0 from "./TeamRoster.vue?vue&type=style&index=0&id=844b43a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports